import {
    // GET_ERRORS,
    // REQUEST_CHILDREN_DATA,
    SUCCESS_DOC_FILES
  } from '../actions/types';
  
  const initialState = {
    docs: [
        
        {
            id: 2,
            name: "Копія свідоцтва про народження дитини (дітей)",
            files: []
        },
        {
            id: 3,
            name: "Копія довідки з ПФУ про сплату ЄСВ (форма ОК-7)",
            files: []
        },
        {
          id: 4,
          name: "Копія рішення суду про встановлення опіки",
          files: []
        },
        {
            id: 5,
            name: "Копія документу, що посвідчує проживання на території України (для іноземців)",
            files: []
        },
       
    ],
   
  };
  
  export default function filesReducer(state = initialState, action) {
    switch (action.type) {
     
      case SUCCESS_DOC_FILES:
        
        return { 
            ...state, 
            docs: action.payload 
        };
      
    
      default:
        return state;
    }
  }